import React from "react";
import { useImmer } from "use-immer";

export const initialAlertState = {
  open: false,
  title: "",
  description: "",
  rowAction: null,
  sx: {},
};

export const AlertContext = React.createContext({
  alert: initialAlertState,
  setAlert: () => {},
});

export const AlertContextProvider = ({ children }) => {
  const [alert, setAlert] = useImmer(initialAlertState);

  // Provide the alert state and setter function
  const value = { alert, setAlert };

  return (
    <AlertContext.Provider value={value}>{children}</AlertContext.Provider>
  );
};
